class Forms {
	constructor() {
		this.labelRequired();
		this.inputDate();
	}

	labelRequired() {
		const spanElements = document.querySelectorAll(".ccm-dashboard-express-form span.text-muted.small");

		spanElements.forEach((span) => {
			span.classList.remove('text-muted');
			span.classList.remove('small');
			span.classList.add('required');
			span.innerText = "*";
		});

		if (spanElements.length > 0) {
			const parrentElement = document.querySelector(".ccm-dashboard-express-form");
			const newLabel = document.createElement("LABEL");
			const labelContent1 = document.createTextNode("Položky označené jako povinné (");
			const labelContent2 = document.createTextNode(") je nutné vyplnit.");
			const newSpan = document.createElement("SPAN");
			newSpan.classList.add('required');
			newSpan.innerText = "*";
			newLabel.appendChild(labelContent1);
			newLabel.appendChild(newSpan);
			newLabel.appendChild(labelContent2);
			parrentElement.appendChild(newLabel);
		}
	}

	inputDate() {
		const inputElements = document.querySelectorAll('.ccm-dashboard-express-form .ccm-input-date');

		inputElements.forEach(element => {
			// element.classList.add('hasDatepicker');
			element.setAttribute('type', 'date');
		})
	}
}

new Forms();
